import * as React from 'react';
import * as _ from 'underscore';
import { ReactActionDialogBodyProps } from '../../commonInfra/dialogs/ReactActionDialog';
import { TextFieldWidget } from '@tableau/widgets';
import { Messages } from '../../codegen/Localize';


export type AddNewOAuthSavedCredentialBodyProps = {
  readonly prompt: string;
  readonly supportsOAuthRole: boolean;
};

export type AddNewOAuthSavedCredentialBodyState = {
  readonly server: string;
  readonly role: string;
};

export type PropsForAddNewOAuthSavedCredentialBody = ReactActionDialogBodyProps<AddNewOAuthSavedCredentialBodyProps, AddNewOAuthSavedCredentialBodyState>;

export function AddNewOAuthSavedCredentialBody(props: PropsForAddNewOAuthSavedCredentialBody): JSX.Element {
  const onServerChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      props.updateDialogState({server: e.target.value});
    },
    [props.updateDialogState]
  );

  const onRoleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      props.updateDialogState({role: e.target.value});
    },
    [props.updateDialogState]
  );

  return (
    <div>
      <div className="tb-edit-connection-sub-header">
        {props.prompt}
      </div>
      <TextFieldWidget
          style={{ width: '450px' }}
          kind='outline'
          label={Messages.enterServer()}
          maxLength={200}
          value={props.dialogState.server}
          onChange={onServerChange}
          disabled={props.actionBusy}
          testId={'tb-oauth-server-text'}
        />
      <div style={{height: '14px'}}></div>
      {props.supportsOAuthRole && <TextFieldWidget
          style={{ width: '450px' }}
          kind='outline'
          label={Messages.addRole()}
          maxLength={100}
          value={props.dialogState.role}
          onChange={onRoleChange}
          disabled={props.actionBusy}
          testId={'tb-oauth-role-text'}
        />}
    </div>
  );
}
